<mat-form-field class="example-form-field" appearance="outline"
    [ngClass]="{'example-form-field-banner':label == 'App Banner *'}">
    <mat-label>{{label}}</mat-label>
    <input matInput type="text" [(ngModel)]="fileName" readonly>
    <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearInput()">
        <span>DELETE</span>
    </button>
</mat-form-field>